<div class="raptor-page-offramp-container">
  <open-raptor-progress *ngIf="!(formData.settings && formData.settings.hide_progress_bar)" [progress]="formData.progress" [pages]="formData.total_pages"></open-raptor-progress>
  <open-raptor-banner-header *ngIf="bannerHeaders" [data]="bannerHeaders"></open-raptor-banner-header>
  <div class="raptor-page-content padding-top-big padding-bottom-xxbig" *ngIf="!raptorStepService.loading">
    <div class="raptor-page-panel" [class]="raptorStepService.action">
      <div class="grid">
        <div class="raptor-page-main-panel cell cell-small-col-span-6 cell-large-col-span-10 cell-large-col-start-2">
          <header class="padding-horizontal-medium" [ngClass]="{'margin-bottom-xmedium': cardLeadOff, 'margin-bottom-small': !cardLeadOff}">
            <h1 *ngIf="formData.heading" class="margin-bottom-medium text-center">{{ formData.heading }}</h1>

            <div *ngIf="layoutSettings && layoutSettings.icon" class="text-center">
              <open-svg-icon [name]="layoutSettings.icon" class="large"></open-svg-icon>
            </div>

            <div
              *ngIf="formData.subtext"
              [innerHTML]="formData.subtext"
              [ngClass]="{
                'text-left': !layoutSettings.align || layoutSettings.align === 'left',
                'text-center': layoutSettings.align === 'center',
                'text-right': layoutSettings.align === 'right'
              }"
            ></div>
          </header>

          <!-- MAIN CONTENT -->
          <div class="raptor-page-column-container margin-bottom-xmedium grid">
            <div class="raptor-page-column-content cell cell-small-col-span-6 cell-large-col-span-12" [ngClass]="{ 'bg-block radius-block': layoutSettings.card === true }">
              <div *ngIf="formData.info && formData.info.settings && formData.info.settings.align === 'top'" class="margin-bottom-small">
                <open-raptor-info [info]="formData.info" [form]="form"></open-raptor-info>
              </div>

              <div *ngFor="let section of formData.sections" class="form-row">
                <open-raptor-section-offramp [section]="section" [form]="form"></open-raptor-section-offramp>
              </div>

              <div *ngIf="formData.info && (!formData.info.settings || (formData.info.settings.align !== 'top' && formData.info.settings.align !== 'below'))">
                <open-raptor-info [info]="formData.info" [form]="form"></open-raptor-info>
              </div>
            </div>
          </div>

          <div
            *ngIf="(formData.actions && formData.actions.next)"
            class="raptor-offramp-action"
          >
            <button mat-flat-button color="primary" type="button" (click)="onRedirect()">
              <span *ngIf="!raptorStepService.loading">{{ (formData.settings && formData.settings.redirect_label) ? formData.settings.redirect_label : 'Back to home' }}</span>
              <mat-spinner *ngIf="raptorStepService.loading" diameter="28"></mat-spinner>
            </button>
          </div>

          <!-- BELOW CONTENT -->
          <div class="raptor-page-column-container grid">
            <div class="raptor-page-column-content cell cell-small-col-span-6 cell-large-col-span-12" [ngClass]="{ 'bg-block radius-block': layoutSettings.card === true }">
              <div *ngIf="formData.info && formData.info.settings && formData.info.settings.align === 'below'" class="margin-top-xmedium">
                <open-raptor-info [info]="formData.info" [form]="form"></open-raptor-info>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="grid grid-wrapper mat-typography margin-top-medium" *ngIf="disclaimers">
    <div class="cell cell-small-col-span-6 cell-large-col-span-12">
      <div *ngFor="let disclaimer of disclaimers; index as i">
        <div *ngIf="disclaimer.type === 'banner'" class="raptor-page-disclaimer text-xsmall" [ngClass]="{'margin-bottom-xsmall':i > 1}">
          {{ disclaimer.content }}
        </div>
      </div>
    </div>
  </div>
</div>
